import { render, staticRenderFns } from "./ButtonEdit.vue?vue&type=template&id=0456b13f"
import script from "./ButtonEdit.vue?vue&type=script&lang=js"
export * from "./ButtonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports